'use strict';

/**
 * @ngdoc function
 * @name informaApp.directive:infIntercom
 * @description
 * # infIntercom
 * Directive of the informaApp
 */

angular.module('informaApp').directive('infIntercom', ["IntercomService", "PendoService", function (IntercomService, PendoService) {
    return {
        restrict: 'E',
        templateUrl: 'directives/inf-intercom/template.ptl.html',

        scope: { },

        link: function(scope, element, attrs) {
            scope.openIntercom = function () {
                IntercomService.show();
                PendoService.track('analysts_support_clicked', {});
            };
        }
    };
}]);

